const MODE = "real"; //real

const MAIN_URL = {
  real: "https://api.ezstart.mn/api",
  test: "http://10.150.10.28:9090/api",
};

const CAR_URL = {
  real: "https://xyp-api.smartcar.mn/xyp-api/v1/xyp/get-data-public",
  test: "https://xyp-api.smartcar.mn/xyp-api/v1/xyp/get-data-public",
};

const PAYMENT_URL = {
  real: "https://merchant.onispos.mn",
  test: "https://merchant.onispos.mn",
};

const PAYMENT_APIKEY =
  "9c4e2a7f0b6d138e5a1c9f3b7d2e84605c8a1f3e9b0d472a6f1c5e8d3b9a204f";
const PAYMENT_SECRET =
  "4e8b2f6a0c9d1e573b5f8a2c6e0d4917b3f7a1c5e9d2840b6f1a3c7e5b9d0248f2a6c0e4b8d1f593a7c5e0b2d4f6810a3c9e7b5d1f0a4c8e2b6d3f59071a4c6e8";

const TERMINAL_ID = "f49b3f35-af6e-442f-b35e-52d42ea617e2";
// "10000161";
const QPAY_INVOICE = {
  invoice: {
    merchant_id: "4f3db212-40d1-43a6-b481-6e9cc2940f9d",
    customer_name: "",
    mcc_code: "5812",
    terminal_id: TERMINAL_ID,
    bank_accounts: [
      {
        is_default: true,
        account_bank_code: "050000",
        account_number: "5628349442",
        account_name: "Ти Эн Саплай",
      },
    ],
  },
};

const URLS = {
  main: MAIN_URL[MODE],
  car: CAR_URL[MODE],
  payment: PAYMENT_URL[MODE],
};

const BANKS = [
  {
    name: "qPay wallet",
    description: "qPay хэтэвч",
    logo: "https://s3.qpay.mn/p/e9bbdc69-3544-4c2f-aff0-4c292bc094f6/launcher-icon-ios.jpg",
    link: "qpaywallet://q?qPay_QRcode=",
  },
  {
    name: "Khan bank",
    description: "Хаан банк",
    logo: "https://qpay.mn/q/logo/khanbank.png",
    link: "khanbank://q?qPay_QRcode=",
  },
  {
    name: "State bank 3.0",
    description: "Төрийн банк 3.0",
    logo: "https://qpay.mn/q/logo/state_3.png",
    link: "statebankmongolia://q?qPay_QRcode=",
  },
  {
    name: "Xac bank",
    description: "Хас банк",
    logo: "https://qpay.mn/q/logo/xacbank.png",
    link: "xacbank://q?qPay_QRcode=",
  },
  {
    name: "Trade and Development bank",
    description: "TDB online",
    logo: "https://qpay.mn/q/logo/tdbbank.png",
    link: "tdbbank://q?qPay_QRcode=",
  },
  {
    name: "Social Pay",
    description: "Голомт банк",
    logo: "https://qpay.mn/q/logo/socialpay.png",
    link: "socialpay-payment://q?qPay_QRcode=",
  },
  {
    name: "Most money",
    description: "МОСТ мони",
    logo: "https://qpay.mn/q/logo/most.png",
    link: "most://q?qPay_QRcode=",
  },
  {
    name: "National investment bank",
    description: "Үндэсний хөрөнгө оруулалтын банк",
    logo: "https://qpay.mn/q/logo/nibank.jpeg",
    link: "nibank://q?qPay_QRcode=",
  },
  {
    name: "Chinggis khaan bank",
    description: "Чингис Хаан банк",
    logo: "https://qpay.mn/q/logo/ckbank.png",
    link: "ckbank://q?qPay_QRcode=",
  },
  {
    name: "Capitron bank",
    description: "Капитрон банк",
    logo: "https://qpay.mn/q/logo/capitronbank.png",
    link: "capitronbank://q?qPay_QRcode=",
  },
  {
    name: "Bogd bank",
    description: "Богд банк",
    logo: "https://qpay.mn/q/logo/bogdbank.png",
    link: "bogdbank://q?qPay_QRcode=",
  },
  {
    name: "Trans bank",
    description: "Тээвэр хөгжлийн банк",
    logo: "https://qpay.mn/q/logo/transbank.png",
    link: "transbank://q?qPay_QRcode=",
  },
  {
    name: "M bank",
    description: "М банк",
    logo: "https://qpay.mn/q/logo/mbank.png",
    link: "mbank://q?qPay_QRcode=",
  },
  {
    name: "Ard App",
    description: "Ард Апп",
    logo: "https://qpay.mn/q/logo/ardapp.png",
    link: "ard://q?qPay_QRcode=",
  },
  {
    name: "Toki App",
    description: "Toki App",
    logo: "https://qpay.mn/q/logo/toki.png",
    link: "toki://q?qPay_QRcode=",
  },
  {
    name: "Arig bank",
    description: "Ариг банк",
    logo: "https://qpay.mn/q/logo/arig.png",
    link: "arig://q?qPay_QRcode=",
  },
  {
    name: "Monpay",
    description: "Мон Пэй",
    logo: "https://qpay.mn/q/logo/monpay.png",
    link: "Monpay://q?qPay_QRcode=",
  },
];

export {
  URLS,
  TERMINAL_ID,
  QPAY_INVOICE,
  BANKS,
  PAYMENT_APIKEY,
  PAYMENT_SECRET,
};
